<input hidden type="file" [multiple]="multiple" #fileDropRef id="fileDropRef" (change)="onFilesSelected($event.target.files)" />

<div
    appDndDocument
    dragoverClasses="animate-pulse"
    (fileDropped)="onFilesSelected($event)"
    class="flex flex-col items-center gap-2 rounded-lg p-6 border-dashed border-2 border-info bg-info bg-opacity-20"
>
    <iota-icon icon="cloud-arrow-up" size="3x"></iota-icon>

    <span class="text-lg" i18n>Drag file(s) here</span>
    <span class="font-light" i18n>or</span>

    <button class="btn" (click)="onSelectClick()">
        <span i18n>Choose files</span>
    </button>
</div>

<div *ngFor="let file of files; let i = index" class="flex flex-row items-center gap-4 mt-2">
    <img *ngIf="previewAvailable(file)" [src]="filePreviews.get(file.name)" class="w-1/4 h-auto" />

    <div class="w-1/4" *ngIf="!previewAvailable(file)">
        <iota-icon [icon]="getHeroFileIcon(file)" size="2x"> </iota-icon>
    </div>

    <span class="break-words">{{ file.name }}</span>

    <button class="btn btn-xs btn-ghost btn-circle" (click)="removeFile(index, file)">
        <iota-icon icon="x-mark" size="1.5"></iota-icon>
    </button>
</div>

<!-- <div
    class="w-full h-hull rounded-xl transition-colors"
    appDndDocument
    [files]="files"
    (fileDropped)="uploadFile($event)"
    *ngIf="files?.length <= 0"
>
    <div class="h-64 flex flex-col justify-center items-center gap-2">
        <strong>Drag file here</strong>
        <strong>oder</strong>
        <button class="btn btn-accent" (click)="openFileDialog()">Datei hochladen</button>
    </div>
    <input hidden name="manualFileUpload" type="file" [accept]="accept" #fileInput (change)="uploadFile($event.target.files)" />
</div>

<br />

<input type="file" name="fileUpload" [accept]="accept" hidden [(ngModel)]="files" />
<div
    class="w-4/5 mx-auto flex flex-row justify-between items-center alert alert-info border-primary p-4"
    *ngFor="let file of files; let i = index"
>
    <p>{{ file }}</p>
    <button class="btn btn-sm btn-ghost btn-circle" (click)="deleteAttachment(i)">
        <iota-icon icon="trash" size="1.5"></iota-icon>
    </button>
</div>

<div class="alert alert-error flex flex-row gap-2" *ngIf="dataCorruptedMessage">
    <iota-icon icon="exclamation-circle" size="1.5"></iota-icon>
    <span>{{ dataCorruptedMessage }}</span>
</div> -->
